import metadata from 'libphonenumber-js/min/metadata';

import {COUNTRIES} from '@time-webkit/all/utils/phone-codes/constants';
import {type MaskitoOptions, MASKITO_DEFAULT_OPTIONS} from '@maskito/core';

import type {MetadataJson} from 'libphonenumber-js/core';
import {AsYouType} from 'libphonenumber-js/core';

import {
    phoneLengthPostprocessorGenerator,
    validatePhonePreprocessorGenerator,
} from './processors';
import {generatePhoneMask, getPhoneTemplate, selectTemplate} from './utils';

/**
 * Источник - https://github.com/taiga-family/maskito/blob/main/projects/phone/src/lib/masks/phone/phone-mask-non-strict.ts
 */
function maskitoPhoneNonStrictOptionsGenerator({
    metadata,
    separator = '–',
}: {
    metadata: MetadataJson;
    separator?: string;
}): Required<MaskitoOptions> {
    const formatter = new AsYouType(undefined, metadata);
    const prefix = '+';
    let currentTemplate = '';
    let currentPhoneLength = 0;

    return {
        ...MASKITO_DEFAULT_OPTIONS,
        mask: ({value}) => {
            const newTemplate = getPhoneTemplate(formatter, value, separator);
            const newPhoneLength = value.replaceAll(/\D/g, '').length;

            currentTemplate = selectTemplate({
                currentTemplate,
                newTemplate,
                currentPhoneLength,
                newPhoneLength,
            });
            currentPhoneLength = newPhoneLength;

            return currentTemplate.length === 1 ? ['+', /\d/] : generatePhoneMask({value, template: currentTemplate, prefix});
        },
        postprocessors: [phoneLengthPostprocessorGenerator(metadata)],
        preprocessors: [
            validatePhonePreprocessorGenerator({
                prefix,
                metadata,
            }),
        ],
    };
}

const COUNTRIES_VALUES = Object.values(COUNTRIES);

const findCountry = (value: string, selected: string) => {
    const code = value.split(' ')[0]?.replace('+', '') ?? '';

    if (!code) {
        return '';
    }

    if (selected) {
        return selected;
    }

    return COUNTRIES_VALUES.find((country) => country.countryCallingCode === code)?.countryCode ?? '';
};

export const getPhoneCountryCode = (value: string, selected: string): string => {
    const formatter = new AsYouType({}, metadata);
    formatter.input(value);
    const countryCode = formatter.getCountry();

    if (!countryCode) {
        return findCountry(value, selected);
    }

    if (!COUNTRIES[countryCode as keyof typeof COUNTRIES]) {
        return '';
    }

    return countryCode;
};

export const maskitoOptions = maskitoPhoneNonStrictOptionsGenerator({metadata});
